;
define("recently_viewed_items.tpl", function(){});

